import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { QueryStatus } from "../../app/types";
import { RootState } from "../../app/store";
import { defaultFlags, FirebaseFlags } from "./firebaseUtils";

interface FirebaseSlice {
  featureFlags: FirebaseFlags;
  featureFlagsStatus: QueryStatus;
  featureFlagsError?: string;
}

const initialState: FirebaseSlice = {
  featureFlags: defaultFlags,
  featureFlagsStatus: "idle"
};

export const firebaseSlice = createSlice({
  name: "firebase",
  initialState,
  reducers: {
    setFeatureFlags: (state, action: PayloadAction<FirebaseFlags>) => {
      state.featureFlags = action.payload;
    },
    setFeatureFlagsStatus: (state, action: PayloadAction<QueryStatus>) => {
      state.featureFlagsStatus = action.payload;
    },
    setFeatureFlagsError: (
      state,
      action: PayloadAction<string | undefined>
    ) => {
      state.featureFlagsError = action.payload;
    }
  }
});

export const { setFeatureFlags, setFeatureFlagsStatus, setFeatureFlagsError } =
  firebaseSlice.actions;

export const selectFeatureFlags = (state: RootState) =>
  state.firebase.featureFlags;
export const selectFeatureFlagsStatus = (state: RootState) =>
  state.firebase.featureFlagsStatus;
export const selectFeatureFlagsError = (state: RootState) =>
  state.firebase.featureFlagsError;

export default firebaseSlice.reducer;
